import { render, staticRenderFns } from "./planeTicket.vue?vue&type=template&id=fe0c24a8&"
import script from "./planeTicket.vue?vue&type=script&lang=js&"
export * from "./planeTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports